import { AreaChart as RechartsAreaChart, ResponsiveContainer, YAxis } from 'recharts'

import { Area, AreaGradient } from '../../../../components/chart/Area'
import { ChartContext } from '../../../../components/chart/ChartWrapper'
import { LineDot } from '../../../../components/chart/LineDot'
import { Tooltip } from '../../../../components/chart/Tooltip'
import { AREA_CHART_HEIGHT, AREA_CHART_MARGIN, AREA_CHART_STYLE } from './constants'

export interface Props {
  data: Array<{ value: number }>
  onActiveTooltipIndexChange: (index: number | null) => void
}

export function AreaChart({ data, onActiveTooltipIndexChange }: Props) {
  return (
    <ChartContext>
      <ResponsiveContainer height={AREA_CHART_HEIGHT}>
        <RechartsAreaChart
          data={data}
          margin={AREA_CHART_MARGIN}
          style={AREA_CHART_STYLE}
          onMouseMove={(state) => onActiveTooltipIndexChange(state.activeTooltipIndex ?? null)}
          onMouseLeave={() => onActiveTooltipIndexChange(null)}
        >
          <defs>
            <AreaGradient id="areaColor" color="lightGray" />
          </defs>
          <YAxis domain={['dataMin', 'dataMax']} hide />
          <Tooltip content={() => null} />
          <Area
            dataKey="value"
            name="Total"
            color="lightGray"
            fill="url(#areaColor)"
            activeDot={<LineDot isActive color="lightGray" />}
          />
        </RechartsAreaChart>
      </ResponsiveContainer>
    </ChartContext>
  )
}
